<common-ui-components-page-layout [title]="title()">
  @if (step()) {
    <div class="container surface-elevated">
      @switch (step()) {
        @case (MANAGEPASSWORDSTEPS.ACTIVATION) {
          <profile-applet-activate-password (returnedOk)="activatePassword()"></profile-applet-activate-password>
        }
        @case (MANAGEPASSWORDSTEPS.OTP) {
          <common-otp-fill-otp
            [mode]="'verification'"
            [editButton]="false"
            [featureForVerification]="[FEATURES[FEATURE_NAMES.SETTINGS_PASSWORD]]"
            (okReturned)="goToStep(MANAGEPASSWORDSTEPS.PIN)"
          ></common-otp-fill-otp>
        }

        @case (MANAGEPASSWORDSTEPS.PIN) {
          <common-pin-layout
            [pinConfig]="{
              newPasswordType: newPasswordType(),
              type: true,
              features: [FEATURES[FEATURE_NAMES.SETTINGS_PASSWORD]],
            }"
            (callbackFunction)="pinCallback($event)"
          ></common-pin-layout>
        }
        @case (MANAGEPASSWORDSTEPS.setBiometric) {
          <common-pin-layout
            [pinConfig]="{
              type: true,
              isBiometricType: true,
              features: [FEATURES[FEATURE_NAMES.SETTINGS_PASSWORD]],
            }"
            (callbackFunction)="pinCallback($event, true)"
          ></common-pin-layout>
        }
        @case (MANAGEPASSWORDSTEPS.MANAGE) {
          <profile-applet-password-settings
            (onBiometricSet)="goToStep(MANAGEPASSWORDSTEPS.setBiometric)"
            [isBiometricActive]="isBiometricActive()"
            (onDelete)="goToStep(MANAGEPASSWORDSTEPS.ACTIVATION)"
          ></profile-applet-password-settings>
        }
      }
    </div>
  }
</common-ui-components-page-layout>
